import React from 'react';
import Pylon2Board from './Pylon2Board';

const Pylon2RightLeg = () => {
  return <Pylon2Board legType="right" />;
};

export default Pylon2RightLeg;
